import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NotifyService, VendorAPI } from 'sustainment-component';
import { CertificationUpdateRequest } from 'sustainment-component';

@Component({
  selector: 'app-cert-update-request',
  providers: [ConfirmationService],
  templateUrl: './certification-update-request.component.html',
  styleUrls: ['./certification-update-request.component.scss'],
  standalone: false
})
export class CertificationUpdateRequestComponent {
  @Input() public companyName: string;
  @Input() public certificationUpdateRequest: CertificationUpdateRequest;
  @Output() public declined = new EventEmitter<void>();
  @Output() public companyClicked = new EventEmitter<void>();
  public isButtonDisabled = false;

  public constructor(
    private confirmationService: ConfirmationService,
    private notifyService: NotifyService,
    private _vendorApi: VendorAPI,
    private router: Router
  ) {}

  public accept(): void {
    this.router.navigateByUrl('/preview-profile/3');
  }
  public decline(): void {
    this.confirmationService.confirm({
      header: `Cancel Certification Update request`,
      message: `You are going to cancel the Certification Update request. Do you wish to continue?`,
      accept: () => {
        this._vendorApi
          .deleteCertificationUpdateRequest(
            this.certificationUpdateRequest.certificationUpdateRequestId
          )
          .subscribe();

        setTimeout(() => {
          this.declined.emit();
        }, 300);
      },
      acceptIcon: 'null',
      acceptLabel: 'Yes, cancel',
      rejectLabel: 'Cancel',
      rejectIcon: 'null'
    });
  }

  public companyClick(event: Event): void {
    event.stopPropagation();
    this.companyClicked.emit();
  }
}
